import { isValid, parse } from "date-fns";

/**
 * Formats people type into a date box. baseui only reads the box's own
 * display format (e.g. "MMM dd, yyyy"), so a typed "2027/01/31" showed in the
 * box but was never saved (QA A6).
 */
const TYPED_FORMATS = [
  "yyyy/M/d",
  "yyyy-M-d",
  "yyyy.M.d",
  "MMM d, yyyy",
  "MMM d yyyy",
  "MMMM d, yyyy",
  "MMMM d yyyy",
  "d MMM yyyy",
  "M/d/yyyy",
];

/**
 * The date a person typed (whole text only), or null when it isn't one.
 * `ownFormat` = the box's display format, tried first.
 */
export const parseTypedDate = (
  text: string | null | undefined,
  ownFormat?: string,
) => {
  const value = (text || "").trim().replace(/\s+/g, " ");
  if (!/\d{4}/.test(value)) return null;
  const formats = ownFormat ? [ownFormat, ...TYPED_FORMATS] : TYPED_FORMATS;
  for (const format of formats) {
    const date = parse(value, format, new Date(2000, 0, 1));
    if (
      isValid(date) &&
      date.getFullYear() >= 1900 &&
      date.getFullYear() <= 2200
    )
      return date;
  }
  return null;
};

export const sameDay = (
  a: Date | null | undefined,
  b: Date | null | undefined,
) =>
  !!a &&
  !!b &&
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();
